import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { api } from "shared/api";

interface Props {
  setIsOpen: (value: boolean) => void;
  reset: () => void;
}
const sendCartOffer = async (cart: any) => {
  const res = await api().gersCreateCart(cart);
  return res.data;
};

export const useSendCartOffer = ({ setIsOpen, reset }: Props) => {
  const {
    mutate: sendCartOfferInEmail,
    status,
    reset: resetSendCartOffer,
  } = useMutation(sendCartOffer, {
    onSuccess: (data) => {
      toast.success("Offerte is verzonden.");
      setIsOpen(false);
      reset();
    },
    onError: () => {
      toast.error("Er is een fout opgetreden.");
    },
  });

  return {
    sendCartOfferInEmail,
    status,
    resetSendCartOffer,
  };
};
